import styled from "styled-components";

export const PlayerStatsSectionGridLayout = styled.div.attrs({
  className: "grid gap-6 xl:grid-cols-2",
})``;

export const PlayerStatsSectionGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-2",
})``;

export const PlayerStatsSectionSection = styled.div.attrs({ className: "mt-8" })``;
